import { createFileRoute } from '@tanstack/react-router';
import { BasicClaimInformation } from '../../../../features/claim/claim/basic-claim-information';
import { getClaimOptions } from '../../../../features/claim/claim/queryOptions';
import { TasksList } from '../../../../features/claim/claim/task-list';
import { ActivitiesList } from '../../../../features/claim/claim/activities-list';

export const Route = createFileRoute('/_authenticated/claims/$guid/_layout/')({
  component: Page,
  loader: ({ context: { queryClient }, params: { guid } }) =>
    queryClient.ensureQueryData(getClaimOptions(guid)),
});

export function Page() {
  const data = Route.useLoaderData();

  return (
    <div className="content-grid">
      <div className="col-span-full">
        <BasicClaimInformation claim={data} />
      </div>

      <div className="col-span-full flex flex-col gap-32">
        <TasksList />

        <ActivitiesList />
      </div>
    </div>
  );
}
